import { async } from "regenerator-runtime";
import * as api from "../api";

export const newProduct = async (productData) => {
  try {
    const { data } = await api.newProduct(productData);
    return data;
  } catch (error) {
    return error;
  }
};
export const setNewEditedProduct = async (editedProductData) => {
  try {
    const { data } = await api.setNewEditedProduct(editedProductData);
    return data;
  } catch (error) {
    return error;
  }
};
export const getProducts = async () => {
  try {
    const { data } = await api.getProducts();

    return data;
  } catch (error) {
    return { requestError: error.response.data };
  }
};

export const setProductStatus = async (data) => {
  try {
    await api.setProductStatus(data);
  } catch (error) {
    return error.response.data;
  }
};

export const statusCount = async () => {
  try {
    const { data } = await api.statusCount();
    return data;
  } catch (error) {
    return error;
  }
};
export const deleteProduct = async (dataDelete) => {
  try {
    const { data } = await api.deleteProduct(dataDelete);

    return data;
  } catch (error) {
    return error;
  }
};

export const getSingleProduct = async (id) => {
  try {
    const { data } = await api.getSingleProduct(id);

    return data;
  } catch (error) {
    return error;
  }
};
export const addToCart = async (item) => {
  try {
    const { data } = await api.addToCart(item);

    return data;
  } catch (error) {
    return error.response.data;
  }
};
export const getCartItem = async () => {
  try {
    const { data } = await api.getCartItem();

    return data;
  } catch (error) {
    return error.response.data;
  }
};
export const editCart = async (cart) => {
  try {
    const { data } = await api.editCart(cart);

    return data;
  } catch (error) {
    return error.response.data;
  }
};
export const deleteToCart = async (cart) => {
  try {
    const { data } = await api.deleteToCart(cart);

    return data;
  } catch (error) {
    return error.response.data;
  }
};
export const addToCheckouts = async (cartData) => {
  try {
    const { data } = await api.addToCheckouts(cartData);
    return data;
  } catch (error) {
    return error.response.data;
  }
};
export const getOrderDetail = async (id) => {
  try {
    const { data } = await api.getOrderDetail(id);
    return data;
  } catch (error) {
    return error.response.data;
  }
};

export const updateTotalProduct = async (total) => {
  try {
    const { data } = await api.updateTotalProduct(total);
    return data;
  } catch (error) {
    return error.response.data;
  }
};
export const getBagOfOrder = async () => {
  try {
    const { data } = await api.getBagOfOrder();
    return data;
  } catch (error) {
    return error.response.data;
  }
};
export const setBillingDetails = async (data) => {
  try {
    await api.setBillingDetails(data);
  } catch (error) {
    return error.response.data;
  }
};
export const getBillingDetails = async () => {
  try {
    const { data } = await api.getBillingDetails();
    return data;
  } catch (error) {
    return error.response.data;
  }
};
export const viewCustomerOrder = async (dataOrder) => {
  try {
    const { data } = await api.viewCustomerOrder(dataOrder);
    return data;
  } catch (error) {
    return error.response.data;
  }
};
export const getCartCountAndBag = async () => {
  try {
    const { data } = await api.getCartCountAndBag();
    return data;
  } catch (error) {
    return error.response.data;
  }
};
export const searchProduct = async (dataSearch) => {
  try {
    const { data } = await api.searchProduct(dataSearch);
    return data;
  } catch (error) {}
};

export const checkoutSession = async (data) => {
  try {
    await api.checkoutSession(data);
  } catch (error) {
    return error.response;
  }
};
